import { render, staticRenderFns } from "./PatientQuickForm.vue?vue&type=template&id=362699ad&scoped=true&lang=pug"
import script from "./PatientQuickForm.vue?vue&type=script&lang=js"
export * from "./PatientQuickForm.vue?vue&type=script&lang=js"
import style0 from "./PatientQuickForm.vue?vue&type=style&index=0&id=362699ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362699ad",
  null
  
)

export default component.exports